import React, { lazy } from 'react';

const BaseRememberedAccountsPage = lazy(() => import('./BasePage'));

const RememberedAccountsPage = () => {
  return <BaseRememberedAccountsPage />;
};

export default RememberedAccountsPage;
